<!-- 公告、政策列表 -->
<template>
<div class='cm_news_list'>
   <!-- 标题 -->
      <div class="cm_news_list_title">
        <h3>{{ele.title?ele.title:ele.name}}</h3>
        <span>您的位置：{{ele.title?ele.title:ele.name}}</span>
      </div>
      <!-- 内容 -->
      <div v-loading="loading" style="min-height:280px">
        <ul class="cm_news_list_content">
          <li  v-for="(item) in dataList" :key="item.NEWS_ID"  @click="toDetail(item.NEWS_ID,ele,item.CHANNEL_NAME)" >
            <h3>{{item.TITLE}}</h3>
            <!--<div class="cm_news_list_content_time">-->
              <!--<span>{{item.SOURCE}}</span>-->
              <span>{{item.PUBLISH_DATE}}</span>
            <!--</div>-->
            
          </li>
        </ul>
          <div class="cm_list_pagination" v-if="totalPage>1">
    <el-pagination
  background
  layout="prev, pager, next"
  :page-count="totalPage"  :current-page.sync="listCurrentPage" @current-change="changePage" >
</el-pagination>
  </div>
      </div>
</div>
</template>

<script>

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
props:["data"],
data() {
//这里存放数据
return {
  dataList:[],
  listCurrentPage:0,
  totalPage:"",
  ele:"",
  loading:true
};
},
//监听属性 类似于data概念
computed: {
},
//监控data中的数据变化
watch: {
  '$route': function (to, from) {
    this.initData()
  }
},
//方法集合
methods: {
  changePage:function(p){
    this.httpPost(p)
  },
  httpPost:function(page) {
     var cData = this.ele.data
    if(page!=""&&page!=undefined&&page!=null&&page!=NaN){
      this.ele.data.currentPage = page
      cData = this.ele.data
    }
    this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: cData
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){

          this.dataList = data.data.pdList
          this.listCurrentPage = data.data.currentPage
          this.totalPage = data.data.totalPage
          this.loading = false
        }
          
      });
    },
    loadItem() {
      let list = this.data.children;

      for (let i = 0; i < list.length; i++) {
       if(this.$route.path.indexOf(list[i].fullPath)==0){
         if(list[i].data != "" && list[i].data != undefined && list[i].data !=null){
           if(this.$route.path==list[i].fullPath){
           this.ele = list[i]
            this.httpPost()
            return false
          }else{
            continue
          }
         }
         else{
            let children = list[i].children
          for (let i = 0; i < children.length; i++) {
            if (children[i].fullPath == this.$route.path) {
              this.ele = children[i]
              this.httpPost()
              return false
            }
          }
         }
           
       
         
        }
      }
    },
    initData(){
      if(this.data!=""&&this.data!=undefined&&this.data!=null){
          if(this.data.data==''||this.data.data==undefined||this.data.data==null){
            this.ele = this.data
            this.loadItem()
          }else{
              this.ele = this.data
              this.httpPost()
          }
      }else{
          this.ele=JSON.parse(window.localStorage.getItem("returnData"))
          this.httpPost()
      }

    },
    toDetail(ID,data,type){

        if(type == "视频点播"){
            this.$router.push({path:'/videoDetail/'+ID,query: {parentData:JSON.stringify(data)}})
            window.localStorage.setItem("returnData",JSON.stringify(this.data))
        }else{
            this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
            window.localStorage.setItem("returnData",JSON.stringify(this.data))
        }
    }

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
  
},

//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.initData();
},

}
</script>
<style scoped>
.cm_news_list{
  padding: 0 30px;
  width: 100%;
  min-height: 100%;
  background: #fff;
}
.cm_news_list_title{
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #4379D3;
}
.cm_news_list_title>h3{
  font-size: 20px;
  font-weight: 500;
  color: #4379D3;
}
.cm_news_list_title>span{
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.cm_news_list_content>li{
  width: 100%;
  border-bottom: 1px solid #DEDEDE;
  padding: 20px 0;
  cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cm_news_list_content>li:hover>h3{
  color: #4379D3;
}
.cm_news_list_content>li>span{
    width: 120px;
    display: flex;
    justify-content: flex-end;
}

.cm_news_list_content>li>h3{
    width: 80%;
  font-size: 18px;
  font-weight: 600;
  color: #565656;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm_news_list_content_time{
  display: flex;
  justify-content: space-between;
}
.cm_news_list_content_time>span{
  font-size: 14px;
  font-weight: 400;
  color: #A4A4A4;
}
.cm_list_pagination{
  margin: 20px 0;
  width: 100%;
  display:flex;
  justify-content: center;
}
</style>